// extracted by mini-css-extract-plugin
module.exports = {"opinion":"Byline_opinion__KhdsO"};